import { DateTime } from "luxon";
import { bitAt } from "./bitset.js";
import type { ScheduleMask, VenueState } from "./types.js";
import type { ScheduleWindow } from "./hours.js";

export const SLOT_MINUTES = 15;

export function slotForDate(date: DateTime, window: ScheduleWindow): number {
  const start = DateTime.fromISO(window.start, { zone: window.timezone });
  return Math.floor(date.setZone(window.timezone).diff(start, "minutes").minutes / SLOT_MINUTES);
}

export function stateAt(schedule: ScheduleMask, slot: number): VenueState {
  if (schedule.status === "missing") return "missing";
  if (schedule.status === "invalid") return "invalid";
  if (bitAt(schedule.uncertainMask, slot)) return "uncertain";
  return bitAt(schedule.openMask, slot) ? "open" : "closed";
}
